import { uniqBy, pickBy } from "lodash";
import * as types from "../constants/ActionTypes";
import { INITIAL_STATE } from "../constants/AppConstants";

const loadDataReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.FETCH_WORKORDERS:
      return Object.assign({}, state, action.value);
    case "CONTRACTS":
      return Object.assign({}, state, action.value);
    case "FETCH_CUSTOMER_SITE":
      return Object.assign({}, state, action.value);
    case types.FETCH_SITES_FROM_SRM:
      return Object.assign({}, state, action.value);
    case types.CLEAR_SITES_FROM_SRM:
      return Object.assign({}, state, action.value);
    case types.FETCH_WORKERS:
      return Object.assign({}, state, action.value);
    case types.FETCH_WORKORDERS_MAP:
      return Object.assign({}, state, action.value);
    case types.FETCH_WORKERS_MAP:
      return Object.assign({}, state, action.value);
    case types.FETCH_PRINTERS:
      return Object.assign({}, state, action.value);
    case types.FETCH_TICKETS:
      return Object.assign({}, state, action.value);
    case types.FETCH_CUSTOMERS:
      return Object.assign({}, state, action.value);
    case types.FETCH_USERS:
      return Object.assign({}, state, action.value);
    case types.FETCH_SECURITY_ROLES:
      return Object.assign({}, state, action.value);
    case types.FETCH_MECHANIC_TYPES:
      return Object.assign({}, state, action.value);
    case types.FETCH_STATUS_CODES:
     return Object.assign({}, state, action.value);
    case types.FETCH_PRODUCT_CLASS:
      return Object.assign({}, state, action.value);
    case types.FETCH_CONFIG_EMAIL:
      return Object.assign({}, state, action.value);
    case types.FETCH_PRODUCT_GROUP:
      let newProductGroups = action.value.productGroups;
      // try to combine the arrays since product group api uses pagination
      try {
        const { group_class } = newProductGroups.results[0];

        newProductGroups.results = uniqBy(
          newProductGroups.results.concat(state.productGroups.results),
          "id"
        ).filter(pg => pg.group_class === group_class);
      } catch (e) {
        // console.log("FETCH PRODUCT GROUP ERROR", e, action);
      }

      return Object.assign(
        {},
        state,
        // remove props that have a value of undefined
        pickBy(
          {
            ...action.value,
            productGroups: newProductGroups
          },
          v => v !== undefined
        )
      );
    case types.CLEAR_PRODUCT_GROUP:
      return Object.assign({}, state, { productGroups: { results: [] } });
    case types.FETCH_MECHANICS:
      return Object.assign({}, state, action.value);
    case types.FETCH_DRIVERS:
      return Object.assign({}, state, action.value);
    case types.FETCH_YARD_INSPECTOR:
      return Object.assign({}, state, action.value);
    case types.FETCH_DATA_ERROR:
      return Object.assign({}, state, action.value);
    case "CUSTOMER_LIST":
      return Object.assign({}, state, action.payload);
    case types.FETCH_REQUESTED_PARTS:
      return Object.assign({}, state, action.value);
    case types.SET_IS_LOADING:
      return Object.assign({}, state, { isLoading: action.payload });
    default:
      return state;
  }
};
export default loadDataReducer;
